import { theme } from "antd";
import { ThemeConfig } from "antd/es/config-provider/context";
import { AliasToken, OverrideToken } from "antd/es/theme/interface";
import { MappingAlgorithm } from "antd/lib";

import { TinyColor as Color } from "@ctrl/tinycolor";
import { defaultsDeep, merge } from "lodash-es";

type ThemeType = "dark" | "light";

export const createCustomTheme = (
  client: ClientSettings,
  isConsignedTheme = false,
) => {
  const byxTheme = client.theme;
  const consignedTheme: ThemeConfig = {
    token: {
      colorPrimary: "#005882",
      colorHighlight: "#005882e6",
    },
  };

  const _customTheme = (
    isConsignedTheme
      ? merge({} as ThemeConfig, byxTheme, consignedTheme)
      : byxTheme
  ) satisfies ThemeConfig;

  const TOKEN: Record<ThemeType, Partial<AliasToken>> = {
    dark: {},
    light: {
      colorBorder: _customTheme.token?.colorPrimary,
    },
  };

  const COMPONENTS: Record<ThemeType, OverrideToken> = {
    dark: {
      Layout: {
        headerBg: "#2e353c",
      },
    },
    light: {
      Layout: {
        headerBg: "transparent",
      },
      Table: {
        colorTextHeading: new Color(_customTheme.token?.colorPrimary)
          .setAlpha(0.7)
          .toHex8String(),
      },
    },
  };

  // "#8a92a6"
  // "#005882"
  // "#70242B"
  // rgb(112, 36, 43)

  const IS_DARK = false;

  const lightAlgorithm: MappingAlgorithm = (designToken) => {
    return {
      ...theme.defaultAlgorithm(designToken),
      colorBgLayout: "transparent",
    };
  };

  const defaultThemeConfig: ThemeConfig = {
    algorithm: lightAlgorithm,
    token: merge(
      {},
      {
        colorInfo: _customTheme.token?.colorPrimary,
        controlHeight: 36,
        fontFamily: "'Rooney Sans', sans-serif", // Specify Rooney Sans and a fallback
      } satisfies ThemeConfig["token"],
      {
        ...(IS_DARK ? TOKEN.dark : TOKEN.light),
      },
    ),
    components: merge({}, {} satisfies ThemeConfig["components"], {
      ...(IS_DARK ? COMPONENTS.dark : COMPONENTS.light),
    }),
  };

  const customTheme = defaultsDeep(
    defaultThemeConfig,
    _customTheme,
  ) as ThemeConfig;

  return customTheme;
};
